'use client'
import { useState } from 'react'
import { AnimatePresence, motion } from 'framer-motion'
import { F0Box } from '@factorialco/f0-react'
import { DeviceImageShowcase } from './DeviceImageShowcase'

export interface DeviceImageCarouselProps {
  images: string[]
}

export const DeviceImageCarousel: React.FC<DeviceImageCarouselProps> = ({ images }) => {
  const [active, setActive] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  if (!images?.length) return null

  return (
    <>
      <F0Box display="flex" flexDirection="row" gap="sm" width="full">
        {images.length > 1 && (
          <div
            style={{ width: '110px', flexShrink: 0, position: 'relative', alignSelf: 'stretch' }}
          >
            <div
              className="flex flex-col gap-2 overflow-y-auto"
              style={{ position: 'absolute', inset: 0 }}
            >
              {images.map((src, index) => (
                <Thumbnail
                  key={`${src}-${index}`}
                  src={src}
                  isActive={index === active}
                  onClick={() => setActive(index)}
                />
              ))}
            </div>
          </div>
        )}

        <div className="cursor-pointer flex-1 min-w-0" onClick={() => setIsOpen(true)}>
          <F0Box flexDirection="row" alignItems="center" border="default" borderRadius="md">
            <AnimatePresence mode="wait">
              <motion.img
                className="w-full object-contain"
                style={{ minHeight: '300px', aspectRatio: '16/9' }}
                key={images[active]}
                src={images[active]}
                initial={{ opacity: 0, scale: 0.98 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 1.02 }}
                transition={{ duration: 0.2 }}
              />
            </AnimatePresence>
          </F0Box>
        </div>

        {isOpen && (
          <DeviceImageShowcase
            activeIndex={active}
            images={images}
            onClose={() => setIsOpen(false)}
          />
        )}
      </F0Box>
    </>
  )
}

function Thumbnail({
  src,
  isActive,
  onClick,
}: {
  src: string
  isActive: boolean
  onClick: () => void
}) {
  return (
    <div className="cursor-pointer shrink-0" onClick={onClick}>
      <F0Box
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        border="default"
        borderRadius="md"
        borderColor={isActive ? 'bold' : undefined}
      >
        <img
          src={src}
          alt=""
          className="p-1 w-full object-contain"
          style={{ aspectRatio: '1/1', height: '60px' }}
        />
      </F0Box>
    </div>
  )
}
